<template>
  <div class="articles-edit">

    <RwvPostEdit
    :postData="article"
    :savingAlert="showSavingAlert"
    :savedAlert="showSavedAlert"
    :errorAlert="showErrorAlert"
    :error="error"
    :categories="categories"
    @submit="onSubmit"
    @delete="onDelete"
    @reset="onReset">

      <template v-slot:tabs>
        <!-- Linked Book -->
        <b-tab title="Linked Book">
          <RwvVariantSelection @changedVariant="changedVariant" class="bg-light"></RwvVariantSelection>

          <b-form-group
            id="input-group-second-product"
            label-for="input-second-product"
            v-b-tooltip.hover
            title="DK-Produkt">

            <b-form-select
              id="input-product"
              :value="article.bookSlug"
              @change="selectedBook">

              <option slot="first" :value="''">
                Buch auswählen...
              </option>

              <option
                v-for="book in filterdBooks"
                :key="book.slug"
                :value="book.slug">

                  {{ book.title }}
                </option>
              </b-form-select>
          </b-form-group>
        </b-tab>

        <b-tab title="Metadaten">
          <b-form-group
            id="input-group-excerpt"
            label-for="input-excerpt"
            description="Taucht als Vorschau in der Artikelliste auf."
            v-b-tooltip.hover
            title="Vorschau">

            <b-form-textarea
              id="input-excerpt"
              v-model="article.excerpt"
              rows="3"
              placeholder="Vorschau">
              </b-form-textarea>
          </b-form-group>
          <b-form-row>
            <b-col>
              <b-form-group
                id="input-group-published-in"
                label-for="input-published-in"
                v-b-tooltip.hover
                title="Ort der Veröffentlichung">

                <b-form-input
                  id="input-published-in"
                  v-model="article.published.in"
                  placeholder="Veröffentlich in ...">
                </b-form-input>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group
                id="input-group-published-on"
                label-for="input-published-on"
                v-b-tooltip.hover
                title="Veröffentlichungsjahr">

                <b-form-input
                  id="input-published-on"
                  v-model="article.published.year"
                  placeholder="Veröffentlich am ...">
                </b-form-input>
              </b-form-group>
            </b-col>
          </b-form-row>
        </b-tab>
      </template>

      <template v-slot:inListPreview>
        <h6>Ansicht auf der Startseite</h6>

        <RwvArticleTile
          :article="article">
        </RwvArticleTile>
      </template>
    </RwvPostEdit>
  </div>
</template>

<script>
import { mapGetters } from "vuex"
import store from "@/store";
import RwvPostEdit from "@/components/Posts/PostEdit";
import RwvArticleTile from "@/components/Articles/ArticleTile";
import RwvVariantSelection from "@/components/VariantSelection";

import {
  slugify
} from "@/common/slugify"
import {
  ARTICLE_PUBLISH,
  ARTICLE_EDIT,
  ARTICLE_DELETE,
  FETCH_ARTICLE,
  ARTICLE_RESET_STATE,
  FETCH_BOOKS,
  FETCH_BOOK
} from "@/store/actions.type";

export default {
  title () {
    return `Bearb.: ${this.article.slug} | So wird's gemacht`
  },
  components: {
    RwvPostEdit,
    RwvArticleTile,
    RwvVariantSelection
  },
  props: {
    previousArticle: {
      type: Object,
      required: false
    }
  },
  data () {
    return {
      srcArticle: {},
      error: {
        title: "",
        message: "",
        stack: ""
      },
      categories: {
        "article": "Artikel",
        "blog": "Blogbeitrag",
        "video": "Video"
      },
      manufacturerSlug: "",
      modelSlug: "",
      variantSlug: "",
      showSavingAlert: false,
      showSavedAlert: false,
      showErrorAlert: false
    }
  },
  async beforeRouteUpdate(to, from, next) {
    // Reset state if user goes from /editor/:id to /editor
    // The component is not recreated so we use to hook to reset the state.
    await store.dispatch(ARTICLE_RESET_STATE);
    return next();
  },
  async beforeRouteEnter(to, from, next) {
    // SO: https://github.com/vuejs/vue-router/issues/1034
    // If we arrive directly to this url, we need to fetch the article
    await store.dispatch(ARTICLE_RESET_STATE);
    if (to.params.slug !== undefined) {
      await store.dispatch(
        FETCH_ARTICLE,
        {
          slug: to.params.slug,
          prevArticle: to.params.previousArticle
        }
      );
    }
    return next();
  },
  async beforeRouteLeave(to, from, next) {
    await store.dispatch(ARTICLE_RESET_STATE);
    next();
  },
  computed: {
    ...mapGetters(["article", "books", "book"]),
    filterdBooks() {
      var me = this;
      var booksToDisplay = [];

      if (me.manufacturerSlug || me.authorSlug) {
        return me.books.filter(function (book) {
          // filter books variants
          var variantApplies = true

          if (me.manufacturerSlug) {
            var variants = book.variants.filter(function(variant) {
              if (me.variantSlug) {
                return variant.slug == me.variantSlug
              } else if (me.modelSlug) {
                return variant.modelSlug == me.modelSlug
              } else {
                return variant.model.manufacturerSlug == me.manufacturerSlug
              }
            })
            variantApplies = (variants.length > 0)
          }

          return variantApplies;
        });
      } else {
        return me.books
      }
    },
  },
  created() {
    this.srcArticle = JSON.parse(JSON.stringify(this.article));

    this.emptyManufacturer = {
        slug: "",
        name: ""
      }
    this.emptyModel = {
        slug: "",
        name: "",
        manufacturer: this.emptyManufacturer
      }
    this.emptyVariant = {
        variant: "",
        year: "",
        slug: "",
        model: this.emptyModel
      }
  },
  mounted() {
    this.$store.dispatch(FETCH_BOOKS);
  },
  methods: {
    changedVariant(manufacturerSlug, modelSlug, variantSlug) {
      this.manufacturerSlug = manufacturerSlug
      this.modelSlug = modelSlug
      this.variantSlug = variantSlug
    },
    async selectedBook(bookSlug) {
      if (bookSlug) {
        await store.dispatch(
          FETCH_BOOK,
          {
            slug: bookSlug
          }
        );
        this.article.bookSlug = this.book.slug
        this.article.linkedBook = this.book
      } else {
        this.article.bookSlug = ""
        this.article.linkedBook = {}
      }
    },
    onSubmit() {
      var me = this;
      var slug = me.srcArticle.slug;
      let action = slug ? ARTICLE_EDIT : ARTICLE_PUBLISH;
      // Start Spinner
      me.showSavingAlert = true;
        console.log(content)

      // Remove Content Ids
      for (var content of me.article.content) {
        delete content.id;
      }
      console.log("me.article.slug")
      console.log(me.article.slug)
      me.article.slug = slugify(me.article.slug)
      // me.$store.dispatch()

      me.$store
        .dispatch(action)
        .then(({ data }) => {
          this.$bvToast.toast("Die Daten wurden erfolgreich gespeichert!", {
            title: "Gespeichert",
            variant: 'success'
          })
            // toaster: 'b-toaster-top-center'
          me.showSavingAlert = false;
        })
        .catch(({ response }) => {
          me.showSavingAlert = false;
          if (response) {
          console.log(response)
            this.$bvToast.toast(response.data.error.message, {
              title: response.data.error.name,
              variant: 'danger'
            })
          } else {
            this.$bvToast.toast("An unknown Error occured", {
              title: "Unknown Error",
              variant: 'danger'
            })
          }
          // me.$bvModal.show("modal-error")
        });
    },
    onDelete() {
      var me = this;
      me.$store
        .dispatch(ARTICLE_DELETE, me.article.slug)
        .then(({ data }) => {
          // this.$bvToast.toast("Das Artikel wurde gelöscht!", {
          //   title: "Gelöscht",
          //   variant: 'success'
          // })
          this.$router.push({ name: "dashboard" });
        })
        .catch(({ response }) => {
          if (response) {
            console.log(response)
            this.$bvToast.toast(response.data.error.message, {
              title: response.data.error.name,
              variant: 'danger'
            })
          } else {
            this.$bvToast.toast("An unknown Error occured", {
              title: "Unknown Error",
              variant: 'danger'
            })
          }
        });
    },
    onReset() {
      this.article = JSON.parse(JSON.stringify(this.srcArticle));
    },
  },
}
</script>


<style lang="scss">
.edit.section {
  .RwvImageCropper {
    img {
      max-width: 80%;
      max-height: 400px;
      margin: auto;
      display: block;
      margin-bottom: 10px;
    }
  }
  .cropper {
    max-height: 26.875rem;
  }
  .form-check-label {
    margin-left: 1.25em;
  }
  .form-check-input {
    margin-left: 0;
  }
  .deactivated {
    opacity: 0.9;
  }
  form {
    margin-bottom: 3rem;
  }
  #input-excerpt {
    min-height: 50px;
  }
}

@media screen and (min-width: $screen-md-min) {
  .splitView {
    clear: both;
    .edit.section, .RwvPost {
      width: 50%;
      float:left;
    }
    .RwvPost {
      border-left: 1px solid rgba(0,0,0,0.35);
    }
    .RwvImageCropper {
      width: 300px;
    }
    .col-md-6 {
      flex: 0 0 100%;
      max-width: 100%;
    }
  }
}
</style>
